<div class="box">
    <div class="myForm">
        <div class="card">
            <h4 class="card-header">User Activity</h4>
            <div class="card-body scroll">
                <form #userForm="ngForm" (ngSubmit)="getRes()">
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>Client</mat-label>
                            <mat-select name="client" placeholder="Client" [(ngModel)]="user.client" required>
                                <mat-option *ngFor="let item of clients" [value]="item.id">{{
                                    item.dname
                                    }}</mat-option>
                            </mat-select>
                            <mat-error>*Client is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <mat-form-field appearance="outline" color="primary">
                            <mat-label>User ID</mat-label>
                            <input matInput [(ngModel)]="user.id" type="text" name="userID"
                                required />
                            <mat-error>*User ID is required</mat-error>
                        </mat-form-field>
                    </p>
                    <p>
                        <button color="primary" class="button" [disabled]="!userForm.valid || buttonClicked"
                            type="submit" mat-raised-button>
                            {{ buttonClicked ? "Getting File" : "Submit" }}
                            <span>
                                <mat-icon *ngIf="buttonClicked">
                                    <mat-spinner diameter="25"></mat-spinner>
                                </mat-icon>
                            </span>
                        </button>
                    </p>
                </form>
            </div>
        </div>
    </div>
</div>
